module.exports = "/_next/static/images/img-hiring-faces-left-bd6bf020bc7723a76480ed2efb6943a1.png";